{
	"backToManageDeclarations": "Retour à la gestion des déclarations"
}
